import React, { useState, useEffect, useMemo } from 'react';
import Decimal from 'decimal.js';
import { type TotalData, OverviewTabKeyNames } from '../../index.type';
import settingInfo from '@/imgs/settingInfo.png';
interface MetricsSelectorProps {
  selectedMetrics: {
    annualReturn?: boolean;
    sharpeRatio?: boolean;
    [key: string]: boolean | undefined;
  };
  selectChange: (key: string, checked: boolean) => void;
  totalData: Pick<TotalData, OverviewTabKeyNames>;
}

const MetricsSelector: React.FC<MetricsSelectorProps> = ({
  selectedMetrics,
  selectChange,
  totalData
}) => {
  const [currentSelectedMetrics, setCurrentSelectedMetrics] = useState<{
    annualReturn?: boolean;
    sharpeRatio?: boolean;
    [key: string]: boolean | undefined;
  }>({});

  useEffect(() => {
    console.log(selectedMetrics, 'selectedMetrics');
    setCurrentSelectedMetrics(selectedMetrics);
  }, [selectedMetrics]);

  const handleCheckboxChange = (key: string, checked: boolean) => {
    console.log(key, checked, 'key, checked');
    selectChange(key, checked);
    setCurrentSelectedMetrics(prev => ({
      ...prev,
      [key]: checked
    }));
  };

  const numberData = useMemo(() => {
    const max_profit_take = new Decimal(totalData.max_profit_take || 0).times(100);
    const sharpe_ratio = new Decimal(totalData.sharpe_ratio || 0).times(100);
    return {
      max_profit_take: max_profit_take.toString(),
      max_profit_take_unit: max_profit_take.greaterThan(0) ? '+' : '-',
      sharpe_ratio: sharpe_ratio.toString(),
      sharpe_ratio_unit: sharpe_ratio.greaterThan(0) ? '+' : '-'
    };
  }, [totalData]);

  return (
    <div>
      {/* 年化收益率 */}
      <div className="my-4 flex items-center justify-between rounded-lg border border-[#F0F0F0] p-3">
        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={currentSelectedMetrics.annualReturn || false}
            onChange={e => handleCheckboxChange('annualReturn', e.target.checked)}
            className="h-4 w-4"
          />
          <span className="text-base font-semibold text-[#1F1F1F]">年化收益率</span>
          <div className="flex h-4 w-4 items-center justify-center">
            <img src={settingInfo} className="h-full w-full object-cover" alt="设置" />
          </div>
        </div>
        <div className="text-base font-semibold text-[#F5222D]">
          {numberData.max_profit_take_unit}
          {numberData.max_profit_take}
          <span className="text-sm">%</span>
        </div>
      </div>

      {/* 夏普比率 */}
      <div className="my-4 flex items-center justify-between rounded-lg border border-[#F0F0F0] p-3">
        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={currentSelectedMetrics.sharpeRatio || false}
            onChange={e => handleCheckboxChange('sharpeRatio', e.target.checked)}
            className="h-4 w-4"
          />
          <span className="text-base font-semibold text-[#1F1F1F]">夏普比率</span>
        </div>
        <div className="text-base font-semibold text-[#F5222D]">
          {numberData.sharpe_ratio_unit}
          {numberData.sharpe_ratio}
          <span className="text-sm">%</span>
        </div>
      </div>
    </div>
  );
};

export default MetricsSelector;
